// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-collapse {\n\tborder-bottom: none;\n\ttext-indent: 2.5em;\n}\n.el-collapse-item__header.is-active {\n\tfont-weight: bolder;\n\tcolor: #000;\n\tbackground: #f1f5f6;\n}\n.el-collapse-item__header {\n\tfont-size: 1.4em;\n\tcolor: #7fd8ce;\n}\n.el-collapse-item__wrap{\n\tbackground: #f1f5f6;\n}\n.el-collapse-item__content{\n\tpadding: 0 2.5em;\n}\n", ""]);
// Exports
module.exports = exports;
